import { useSubscriptionMap } from 'api/goodtrust/subscription'
import { PlanType } from 'logic/subscription/plan/types'

export function useSubscriptionItem(planType?: PlanType) {
  const map = useSubscriptionMap()
  if (planType == null) return planType
  return map.data?.json?.subscriptions?.[planType]
}
